import {App} from "./home/app.mjs";
console.log('app',App)
export default App;